<template>
  <div class="c-header-img">
    <img src="../assets/images/baner_02_03.jpg" alt="Audi - Samochody nowe">
  </div>
</template>
<script>
export default {
  name: 'HeaderImg'

}
</script>
<style lang="scss">
  .c-header-img{
    img{
      width: 100%;
      height: auto;
    }
  }
</style>
